import { FilterFieldDefinition } from '../../composables/useUrlFilters';
import { UrlFilterSerializer } from '../UrlFilterSerializer';

export const ProductFilterDefinitions: FilterFieldDefinition[] = [
    {
        key: 'productId',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'sku',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'categoryCode',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.categoryOptions?.some((opt: any) => opt.code === value) ?? false;
        }
    },
    {
        key: 'title',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'description',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'dateCreateAtFrom',
        type: 'date',
        defaultValue: null,
        serialize: UrlFilterSerializer.serializeDate,
        deserialize: UrlFilterSerializer.deserializeDate
    },
    {
        key: 'dateCreateAtTo',
        type: 'date',
        defaultValue: null,
        serialize: UrlFilterSerializer.serializeDate,
        deserialize: UrlFilterSerializer.deserializeDate
    }
];
